import { useState } from 'react'
import { Link, useHydrated } from '@tanstack/react-router'

const COOKIE = 'cookieBannerClosed'

export function CookieBanner() {
  const hydrated = useHydrated()
  // The cookie remembers the choice across visits; this closes the banner now.
  const [dismissed, setDismissed] = useState(false)

  // Hidden until hydrated so prerendered HTML never shows it (and never reads
  // document.cookie on the server).
  if (!hydrated || dismissed || document.cookie.includes(`${COOKIE}=`)) {
    return null
  }

  function accept() {
    document.cookie = `${COOKIE}=true; max-age=${90 * 24 * 60 * 60}; path=/`
    setDismissed(true)
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      className="fixed bottom-2.5 left-2.5 z-[999] flex w-60 items-center rounded-[10px] bg-surface py-5 pr-1.5 pl-5 text-[13px] shadow-[0_4px_8px_0_rgba(0,0,0,.2),0_6px_20px_0_rgba(0,0,0,.19)]"
    >
      <p className="m-0">
        We use cookies to improve your experience on our site. By using our
        site, you agree to our{' '}
        <Link
          to="/privacy-policy"
          className="font-bold text-fg-body hover:underline"
        >
          Privacy Policy
        </Link>
        .
      </p>
      <button
        type="button"
        onClick={accept}
        className="m-2.5 cursor-pointer rounded-[3px] bg-royal p-2.5 text-white transition-colors hover:bg-royal-dark"
      >
        OK
      </button>
    </div>
  )
}
